<template>
  <div>
    <ModalEditHorasGlobal :open="modalhorastate" @updateRangoHoras="updateRangoHoras" @close="closeEditModalHoras" />

    <ModalMapaFaenas :showModalMapa="showModalMapa" :propIdFaena="this.idFaena" @close="closeModal"> </ModalMapaFaenas>
    <ModalLayoutJaulas :showModalLayout="showModalLayout" :propIdFaena="this.idFaena" @close="closeModalLayout">
    </ModalLayoutJaulas>
    <MenuAyuda :showModalAyuda="showModalAyuda" @close="closeModalAyuda"></MenuAyuda>
    <ModalVisibilidad :objJaulas="objJaulas" :showModalVisibilidad="showModalVisibilidad" @close="closeModalVisibilidad"
      @handleVisibilidad="handleVisibilidad"></ModalVisibilidad>
    <ModalRangoFechas :propIdFaena="propIdFaena" :showModalVisibilidad="showModalRangoFechas"
      @close="closeModalRangoFechas" @handleRangoFechas="handleRangoFechas"></ModalRangoFechas>
    <div class="grid xs:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-1">
      <div class="container mx-auto  p-1">

        <div class="w-full text-left  ml-0">
          <span class="text-1xl text-white font-bold text-black text-left">
            Live {{ $t('centro') }} {{ nombreFaena }}</span>
          <span class="text-1xl text-white text-black text-left ml-5">
            <b>{{ $t('origen') }}:</b> {{ fechahoraActual }}</span>
          <span class="ml-3 text-1xl text-white  text-black text-left ml-2">
            <b> Local:</b> {{ fechahoraLocal }}</span>
        </div>

        <div class="flex flex-wrap lg:flex-nowrap">
          <div class="w-full lg:w-2/3 pl-0">

            <div class="container">
              <div class="w-full">
                <div
                  class="w-full grid lg:grid-cols-4 sm:grid-cols-2  grid-cols-2  gap-2 bg-white p-2 rounded-lg shadow">

                  <div
                    class="flex items-center justify-center p-2 bg-blue-700 text-white text-sm font-medium rounded-md">
                   <span v-html="$t('pureza_oxigeno')"></span>
                  </div>
                  <div class="flex items-center pl-2 text-sm text-gray-900 hover:text-gray-600">
                    <a href="#">{{ purezao2 }} %</a>
                  </div>

                  <div
                    class="flex items-center justify-center p-2 bg-blue-700 text-white text-sm font-medium rounded-md">
              
                        <span v-html="$t('flujo_oxigeno')"></span>
                  </div>
                  <div class="flex items-center pl-2 text-sm">
                    <a href="#">{{ flujoo2 }} kg/h</a>
                  </div>

                  <div
                    class="flex items-center justify-center p-2 bg-green-500 text-white text-sm font-medium rounded-md">
                    O<sub>2</sub> Natural
                  </div>
                  <div class="flex items-center pl-2 text-sm">
                    <a href="#">{{ o2natural }} {{ o2naturalume }}</a>
                  </div>

                  <div
                    class="flex items-center justify-center p-2 bg-green-500 text-white text-sm font-medium rounded-md">
                    {{ $t('salinidad') }}
                  </div>
                  <div class="flex items-center pl-2 text-sm">
                    <a href="#">{{ salinidad }} {{ salinidadume }} </a>
                  </div>

                </div>

              </div>

            </div>
          </div>

          <!-- Segunda sección -->
          <div class="w-full lg:w-1/3 pl-8 pr-2 text-center">



            <div class="grid grid-cols-6 sm:grid-cols-6 md:grid-cols-6 gap-6 p-0">
              <a href="#" class="group flex flex-col items-center justify-between 
              p-2 rounded-lg transition duration-150 ease-in-out hover:bg-gray-50" @click="loadModalRangoFechas(true)">
                <div
                  class="flex-shrink-0 inline-flex h-11 w-11 sm:h-10 sm:w-10 items-center justify-center rounded-md bg-indigo-500 text-white">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-8 h-8">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M8 2v2M16 2v2M3 8h18M5 4h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2z" />
                  </svg>
                </div>
                <p class="text-xs text-gray-900 mt-1">  {{ $t('calendario') }}</p>
              </a>
              <btnHoras @emitModalEditHorasGlobal="loadModalEditHorasGlobal" />
              <a href="#"
                class="group flex flex-col items-center justify-between p-2 rounded-lg transition duration-150 ease-in-out hover:bg-gray-50"
                @click="loadModalVisibilidad(true)">
                <div
                  class="flex-shrink-0 inline-flex h-11 w-11 sm:h-10 sm:w-10 items-center justify-center rounded-md bg-indigo-500 text-white">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-8 h-8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M2.458 12C3.732 7.943 7.522 5 12 5c4.478 0 8.268 2.943 9.542 7-.034.096-.07.192-.106.287C20.268 16.057 16.478 19 12 19c-4.478 0-8.268-2.943-9.542-7-.036-.095-.072-.191-.106-.287z" />
                  </svg>
                </div>
                <p class="text-xs text-gray-900">  {{ $t('visibilidad') }}</p>
              </a>

              <a href="#"
                class="group flex flex-col items-center justify-between p-2 rounded-lg transition duration-150 ease-in-out hover:bg-gray-50"
                @click="loadAyuda()">
                <div
                  class="flex-shrink-0 inline-flex h-11 w-11 sm:h-10 sm:w-10 items-center justify-center rounded-md bg-indigo-500 text-white">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-8 h-8">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                  </svg>
                </div>
                <p class="text-xs text-gray-900"> {{ $t('informacion') }}</p>
              </a>

             
             
            </div>


          </div>
        </div>
        <div class="w-full">


          <SimbolosJaulas />


        </div>


      </div>
    </div>

    <div class="bg-white">


      <div class="flex flex-wrap">

        <div class="w-full ">

          <div v-if="dataLoaded == false" class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1 mt-8"> 
          {{ $t('cargando_jaulas') }} ... </div>


          <GraficosLiveCentros :idEmpresa="idEmpresa" :propIdFaena="propIdFaena" 
            :propObjJaulas="objJaulas"
            :invervalohoras="invervalohoras" :propRangoFechas="objRangoFechas">
          </GraficosLiveCentros>

        </div>
      </div>


    </div>
  </div>
</template>
<style scoped>
footer {
  z-index: 5000;
  width: 900px;
  height: 86px;
  padding-top: 4px;
  padding-bottom: 6px;
}

header {
  padding-top: 2px;
  z-index: 5000;
  width: 300px;
  height: 200px;
  margin-left: 200px;

}
</style>

<script>
import axios from "axios";
//import i18n from '@/i18n';
import GraficosLiveCentros from "./GraficosLiveCentros";
import ModalMapaFaenas from "../resumen/modal/ModalMapaFaenas";
import ModalLayoutJaulas from "../resumen/modal/ModalLayoutJaulas";
import ModalVisibilidad from "./modal/ModalVisibilidad";
import ModalRangoFechas from "./modal/ModalRangoFechas";
import MenuAyuda from "./MenuAyuda";
 
 
import btnHoras from "./ui/btnHoras";
import ModalEditHorasGlobal from "./modal/ModalEditHorasGlobal";
import SimbolosJaulas from "./ui/SimbolosJaulas.vue";
import {  mapGetters  } from 'vuex'
export default {
  name: "FaenasCliente",
  props: ["idEmpresa", "propIdFaena", "nombreFaena", "numRam"],
  emits: ['chgFaena', 'handleDropFaena'],
  components: {
    GraficosLiveCentros, ModalLayoutJaulas,  
    ModalMapaFaenas, MenuAyuda, ModalVisibilidad,  
    ModalRangoFechas, btnHoras, ModalEditHorasGlobal, SimbolosJaulas
  },
  computed: {
  ...mapGetters(['getStateInyeccionTrue']),
 },
  mounted() {

    const setpoints = this.$store.state.login.userLogin.info.default_setpoints;
    let resultado = setpoints.find(item => item.idPar === 5);
    this.o2naturalume = resultado ? resultado.unMedida : null;


    let f = this.$store.state.faenas;
    let obj = f.faenas.filter(item => item.id === this.idFaena);
    if (Array.isArray(obj[0].unidades)) {
      let objJaulas = obj[0].unidades.filter(unidad => unidad.tipo == "Plataforma" && unidad.natural == 'S');

      if (objJaulas && typeof objJaulas === 'object') {

        this.unidadNatural = objJaulas[0].id;

        const firstJaula = objJaulas[0];
        if (firstJaula && firstJaula.id && Array.isArray(firstJaula.sensores) && firstJaula.sensores.length === 0) {




          let sensorbuscado = objJaulas[0].sensores[0];
          const parametro_sensores = this.$store.state.login.userLogin.info.parametro_sensores;
          let sensor_aquatrol = parametro_sensores.filter(sensor => sensor.id == sensorbuscado)
          let salinidad = [];
          if (Array.isArray(sensor_aquatrol) && sensor_aquatrol.length > 0 && Array.isArray(sensor_aquatrol[0].parametros)) {
            salinidad = sensor_aquatrol[0].parametros.filter(parametro => parametro.id == 2);
            if (salinidad.length > 0) {
              this.salinidadume = salinidad[0].unidad;
            }
          }

        }


      }
    }


 
    this.idFaena = this.propIdFaena;
    this.loadUnidades()
    this.loadUnidades_natural()
    this.fechahora();
    this.getCoordenadas();
    this.getdataSondaAquaTroll();
    this.revisaInyecciones();
    this.polldata();
    this.pollHora();
    this.pollInyecciones();
  },
  data() {
    return {
      o2natural: '--',
      o2naturalume: '',
      salinidad: '--',
      salinidadume: 'PSU',
      unidadNatural: 'mg/l',
      orp: 0,
      purezao2: '--',
      flujoo2: '--',
      idParamSalinidad: 2,
      idParamO2Natural: 5,
      invervalohoras: 0,
      seriesLoaded: false,
      dataLoaded: false,
      datos_mensuales: [],
      faenas: [{}],
      cards: [{}],
      objFaenas: [{}],
      seriesFaenas: [],
      modalhorastate: false,
      numRamdom: this.numRam,
      showModalMapa: false,
      showModalLayout: false,
      showModalAyuda: false,
      unidadTipoPlanta: {},
      idFaena: this.propIdFaena,
      objJaulas: [],
      objJaulasVisibles: [],
      showModalVisibilidad: false,
      showModalRangoFechas: false,
      fechahoraActual: '',
      fechahoraLocal: '',
      tieneCoordenadas: false,
      objRangoFechas: {},
      polling:{},
      polling2:{},
      polling3:{}
    };
  },
  methods: {
    polldata() {
      this.polling = setInterval(() => {

        this.getdataSondaAquaTroll();
      }, 15000); //
    },
    pollHora() {
      this.polling2 = setInterval(() => {
        // this.getdataendpoint_endesuso() ;
        this.fechahora()
      }, 1);
    },
    pollInyecciones(){
      this.polling3 = setInterval(()=>{
        this.revisaInyecciones()
      },5000);
    },
    updateRangoHoras(valor) {
      this.modalhorastate = false;
      this.invervalohoras = valor;
    },
    loadModalEditHorasGlobal() {
      this.modalhorastate = true;
    },
    revisaInyecciones(){
          let inyeccion=this.getStateInyeccionTrue();
          if(inyeccion){
           
            this.purezao2='93.5';
             this.flujoo2='172';
          }else{
            this.purezao2='--';
             this.flujoo2='--';
          }
          console.log('inyeccion',inyeccion)
    },
    async getdataSondaAquaTroll() {
      let objFecha = this.$store.getters.fechaHoraActual(this.propIdFaena);
      const y = objFecha.getFullYear;
      const m = String(objFecha.getMonth).padStart(2, '0');
      const d = String(objFecha.getDate).padStart(2, '0');

      const h = String(objFecha.getHours).padStart(2, '0');
      const min = String(objFecha.getMinutes).padStart(2, '0');
      const s = String(objFecha.getSeconds).padStart(2, '0');

      //let objFechaHora = DateTime.fromObject(
      //  { year: y, month: m, day: d, hour: h, minute: min, second: s },
      //  { zone: 'America/Santiago' }
      //);

      this.fFinal = `${y}-${m}-${d}T${h}:${min}:${s}`;

      let objFechaHora = this.$store.getters.dateFactory(this.fFinal, this.propIdFaena);
      let minuto_en_ms = 1 * 60 * 1000;
      let fInicial = objFechaHora.subtractMillis(minuto_en_ms);
      fInicial = fInicial.split('.')[0];

      console.log('aquatroll', `${fInicial}`, `${this.fFinal}`)

      const apiKey = this.$store.state.login.tokenLogin;
      const data = {
        idUnit: this.unidadNatural,
        tsi: `${fInicial}`,
        tsf: `${this.fFinal}`,
        granularity: ``
      };

      const fetchData = async () => {
        try {
          const url = "/api/mon/getUnitData";
          const response = await axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `${apiKey}`

            }
          });

          console.log('aquatrol', data);

          const params = response.data.payload.sensors[0].params;



          let obj = params.filter(param => param.id === this.idParamSalinidad);
          if (Array.isArray(obj)) {
            let values = [...obj[0].values].splice(-1);
            this.salinidad = values[0].value ? values[0].value : '--';
          }
          obj = params.filter(param => param.id === this.idParamO2Natural);
          if (Array.isArray(obj)) {
            let values = [...obj[0].values].splice(-1);
            this.o2natural = values[0].value ? values[0].value : '--';
          }


        } catch (error) {
          console.error("Error al obtener datos:", error);
          return false;
        }
      };

      fetchData().then(() => {


        this.result_mediciones = true;

      }).catch(error => {
        console.error("Error processing data:", error);
      });


    },
    getCoordenadas() {
      let objStoreFaenas = this.$store.state.faenas;
      this.objFaena = objStoreFaenas.faenas.filter(faena => faena.id == this.propIdFaena);
      if (Array.isArray(this.objFaena) && this.objFaena.length > 0) {

        let longitud = this.objFaena[0]["longitud"];
        let latitud = this.objFaena[0]["latitud"];
        if (longitud && latitud) {
          this.tieneCoordenadas = true;
        }
      }
    },
    loadModalVisibilidad(valor) {
      console.log("modifica estado modal");
      this.showModalVisibilidad = valor;
    },
    loadModalRangoFechas(valor) {
      console.log("modifica estado modal");
      this.showModalRangoFechas = valor;
    },
    handleVisibilidad() {
      // this.$emit("handleDropFaena");
      console.log('handle visibilidad jaula')
      this.loadUnidades()
      this.$emit("handleDropFaena");
    },
    handleRangoFechas(valor) {
      console.log('handleRangoFecs', valor)

      this.objRangoFechas = valor;
      this.showModalRangoFechas = false;

    },
    getRnd(min, max) {
      let flot = Math.random() * (max - min + 1) + min;

      return flot.toFixed(2)
    },
    loadMapa() {
      console.log('LOAD MAPA')
      this.showModalMapa = true
    },
    loadLayout() {
      console.log('LOAD LAYOUT')
      this.showModalLayout = true
    },
    loadAyuda() {
      console.log('LOAD AYUDA')
      this.showModalAyuda = true
    },
    closeModal() {
      this.showModalMapa = false
    },
    closeModalLayout() {
      this.showModalLayout = false
    },
    closeModalAyuda() {
      this.showModalAyuda = false
    },
    closeModalVisibilidad() {
      this.showModalVisibilidad = false;
    },
    closeModalRangoFechas() {
      this.showModalRangoFechas = false;
    },
    closeEditModalHoras() {
      this.modalhorastate = false;
    },
    fechahora() {

      this.objFechaActual = this.$store.getters.fechaHoraActual(this.propIdFaena);
      this.fechahoraActual = `${this.objFechaActual.fechaHora}  (${this.objFechaActual.zoneName})`;

      const ahora = new Date();
      const dia = String(ahora.getDate()).padStart(2, '0');
      const mes = String(ahora.getMonth() + 1).padStart(2, '0');
      const anio = ahora.getFullYear();

      const horas = String(ahora.getHours()).padStart(2, '0');
      const minutos = String(ahora.getMinutes()).padStart(2, '0');
      const segundos = String(ahora.getSeconds()).padStart(2, '0');
      const zonaHoraria = Intl.DateTimeFormat().resolvedOptions().timeZone;

      this.fechahoraLocal = `${dia}-${mes}-${anio} ${horas}:${minutos}:${segundos} (${zonaHoraria})`;


    },

    loadUnidades() {
      let storeVacio = true;
      console.log('storeJaulas', this.$store.state.jaulas.Jaulas)
      if (this.$store.state.jaulas.Jaulas.length > 0) {
        this.storeJaulas = this.$store.state.jaulas;
        storeVacio = false;
      }

      this.f = this.$store.state.faenas;
      let obj = this.f.faenas.filter(item => item.id === this.idFaena);
      if (Array.isArray(obj[0].unidades)) {
        this.objJaulas = obj[0].unidades.filter(unidad => unidad.natural !== "S");
        //this.objJaulas = obj[0].unidades.filter(unidad => unidad.id == "1101");

        if (Array.isArray(this.objJaulas)) {

          this.objJaulasVisibles = this.objJaulas.map(jaula => {

            if (!storeVacio) {
              let arrayJaula = this.storeJaulas.Jaulas.filter(store => store.id == jaula.id && store.visible == false);
              console.log('revisa:', jaula.id, arrayJaula.length)
              if (arrayJaula.length > 0) {

                jaula.visible = false;

              } else {
                jaula.visible = true;
              }



            } else {
              // no existe jaula en el store visibilidad jaulas
              jaula.visible = true;

              // this.$store.dispatch("jaulaAdd", jaula);
              return jaula;
            }


          });


        }

        this.dataLoaded = true;
      }


    },
    loadUnidades_natural() {
      this.o2natural = '--';
      this.orp = '--';

      let objJaulas = []
      let f = this.$store.state.faenas;
      let obj = f.faenas.filter(item => item.id === this.idFaena);
      if (Array.isArray(obj[0].unidades)) {
        objJaulas = obj[0].unidades.filter(unidad => unidad.natural == 'S');


        if (objJaulas && typeof objJaulas === 'object') {


          const jaula = objJaulas[0];
          if (jaula && 'id' in jaula) {
            this.unidadTipoPlanta.id = jaula.id;
          }
          if (jaula && 'sensores' in jaula) {
            this.unidadTipoPlanta.sensores = jaula.sensores;
          }

        }
      }
    },

  },
  beforeUnmount() {
    clearInterval(this.polling);
    clearInterval(this.polling2);
  },
  watch: {

    propIdFaena: function (value) {
      this.dataLoaded = false;
      this.idFaena = value;
      this.loadUnidades();
      this.loadUnidades_natural();
    }
  }


};
</script>